import { Database } from "@/lib/supabase/types";

type Tables = Database["public"]["Tables"];
type Enums = Database["public"]["Enums"];

export type StepId = Tables["steps"]["Row"]["id"];
export type ChapterId = Tables["chapters"]["Row"]["id"];
export type SectionId = Tables["sections"]["Row"]["id"];
export type TaskId = Tables["tasks"]["Row"]["id"];
export type TaskType = Enums["task_type"];
export type SubscriptionTier = Enums["subscription_tier"];

type TaskDataSchemaByVersion = {
    1: {
        data: string[];
    };
    2: {
        data: Record<string, string>;
    };
};

export type VersionedTaskData = {
    [V in keyof TaskDataSchemaByVersion]: {
        version: V;
    } & TaskDataSchemaByVersion[V]
}[keyof TaskDataSchemaByVersion];

type LatestVersion = 2;

export type TaskData = Extract<VersionedTaskData, { version: LatestVersion }>;

export function migrateTaskDataToLatest(data: VersionedTaskData): TaskData {
    if (!data) {
        return {
            data: {},
            version: 2,
        };
    }
    switch (data.version) {
        case 1:
            return {
                version: 2,
                data: data.data.reduce((acc, curr, index) => {
                    acc[index] = curr;
                    return acc;
                }, {})
            };
        case 2:
            return data; // already latest
    }
}


export type TaskContent = {
    id?: number;
    title?: string;
    body?: string | string[];
    hasTextBox?: boolean;
    audioSrc?: string;
    supabaseAudioSrc?: string;
    lines?: number;
    imagePath?: string;
}[];

export type ChapterEntry = {
    id: ChapterId;
    title: string;
    number: number;
    next_chapter?: ChapterId;
    prev_chapter?: ChapterId;
    effective_tier: SubscriptionTier;
    has_access: boolean;

};

export type SectionEntry = {
    id: SectionId;
    chapter_id: ChapterId;
    title: string;
    number: number;
    text: string;
    next_section?: SectionId;
    prev_section?: SectionId;
    effective_tier: SubscriptionTier;
    has_access: boolean;
};

export type TaskEntry = {
    id: TaskId;
    section_id: SectionId;
    type: TaskType;
    content: TaskContent;
    effective_tier: SubscriptionTier;
    has_access: boolean;
};

export type CompletedTaskEntry = {
    task_id: TaskId;
    task_data: TaskData;
    completed?: boolean;
};

export type StepEntry = {
    id: StepId;
    title: string;
    number: number;
    next_step?: StepId;
    effective_tier: SubscriptionTier;
    has_access: boolean;
};